<template>
  <div class="d-inline" :class="dropdownWrapperClass">
    <button ref="dropdownBtn" type="button" v-bind="btnAttrs">
      <slot />
    </button>
    <div
      class="dropdown-menu p-3 border-radius-0"
      :class="props.dropdownClass"
      :style="'min-width: ' + confirm.minWidth + ';'"
    >
      <div class="col-12">
        <h6 class="dropdown-header p-0" v-if="confirm.header">
          <slot name="confirm-header">Bitte bestätigen</slot>
        </h6>
      </div>
      <div class="px-3" v-if="slots['confirm-message']">
        <slot name="confirm-message"></slot>
      </div>
      <div class="" v-if="confirm.header || slots.confirmMessage"></div>

      <div class="row mt-3" role="group">
        <div class="col-sm-6">
          <button
            type="button"
            :class="'btn w-100 border-radius-0 btn-' + confirm.btnVariant"
            @click="onConfirm"
          >
            {{ confirm.yes }}
          </button>
        </div>
        <div class="col-sm-6">
          <button
            type="button"
            :class="
              'btn w-100 border-radius-0 btn-outline-' + confirm.btnVariant
            "
            @click="onCancel"
          >
            {{ confirm.no }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, computed, useSlots } from "vue";
const emit = defineEmits(["confirmed", "cancel", "change"]);
const slots = useSlots();

const dropdownBtn = ref(null);

const props = defineProps({
  btnAttrs: {
    type: Object,
  },
  confirm: {
    type: Object,
  },
  centered: {
    type: Boolean,
    default: true,
  },
});

const dropdownWrapperClass = computed(() =>
  props.centered ? "dropdown-center" : "dropdown"
);

const btnAttrs = computed(() => ({
  ...{
    class: "btn btn-primary",
    "data-bs-toggle": "dropdown",
    "aria-expanded": "false",
    "data-bs-auto-close": "outside",
  },
  ...props.btnAttrs,
}));

const confirm = computed(() => ({
  ...{
    yes: "Ja",
    no: "Nein",
    minWidth: "300px",
    header: true,
    btnVariant: "primary",
  },
  ...props.confirm,
}));

function onConfirm() {
  emit("confirmed");
  emit("change");
}

function onCancel() {
  dropdown().hide();
  emit("cancel");
  emit("change");
}

function dropdown() {
  return window.bootstrap.Dropdown.getOrCreateInstance(dropdownBtn.value);
}
</script>
